import React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgAddCircleFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 4l-.117.007A1 1 0 0011 7v4H7l-.117.007A1 1 0 006 12l.007.117A1 1 0 007 13h4v4l.007.117A1 1 0 0012 18l.117-.007A1 1 0 0013 17v-4h4l.117-.007A1 1 0 0018 12l-.007-.117A1 1 0 0017 11h-4V7l-.007-.12A1 1 0 0012 6z", fill: color, fillRule: "evenodd" }));
};
export default factorySvgIcon(SvgAddCircleFilled);
//# sourceMappingURL=SvgAddCircleFilled.js.map